/*
 * Copyright (C) 2026 Fluxer Contributors
 *
 * This file is part of Fluxer.
 *
 * Fluxer is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * Fluxer is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with Fluxer. If not, see <https://www.gnu.org/licenses/>.
 */

import {Input} from '@app/components/form/Input';
import {observer} from 'mobx-react-lite';

interface FormFieldProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange'> {
	name: string;
	label?: React.ReactNode;
	value: string;
	error?: string;
	placeholder?: string;
	onChange: (value: string) => void;
}

const FormField = observer(function FormField({name, label, value, error, onChange, ...props}: FormFieldProps) {
	return (
		<Input
			name={name}
			label={typeof label === 'string' ? label : undefined}
			value={value}
			error={error}
			onChange={(e) => onChange(e.target.value)}
			{...props}
		/>
	);
});

export default FormField;
